"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoSelectSingleValidValue = autoSelectSingleValidValue;
exports.createDefaultProperties = createDefaultProperties;
const property_1 = require("@genesys/property");
const PropertyFilterHelpers = __importStar(require("../property-filter-helpers"));
function autoSelectSingleValidValue(productProperties, properties, changedPropertyName) {
    let lastProperties = properties;
    const discretePropertiesWithValidationFilter = productProperties.filter(x => x.quantity === "Discrete" && x.validationFilter !== undefined);
    for (let i = 0; i < 4; i++) {
        for (const productPropertyWithValidationFilter of discretePropertiesWithValidationFilter) {
            const { name, values } = productPropertyWithValidationFilter;
            if (name === changedPropertyName || name.startsWith("range")) {
                continue;
            }
            const propertyValueItem = getSingleValidValueOrUndefined(productPropertyWithValidationFilter, properties);
            if (propertyValueItem) {
                properties = property_1.PropertyValueSet.set(name, property_1.PropertyValue.fromInteger(parseInt(propertyValueItem.value, 10)), properties);
            }
            const selectedValueItem = property_1.PropertyValueSet.hasProperty(name, properties) &&
                values.find(v => v.value ===
                    property_1.PropertyValue.toString(property_1.PropertyValueSet.get(name, properties)));
            if (selectedValueItem &&
                !PropertyFilterHelpers.isValid(selectedValueItem.validationFilter, property_1.PropertyFilter.Empty, properties)) {
                const firstValid = values.find(v => PropertyFilterHelpers.isValid(v.validationFilter, property_1.PropertyFilter.Empty, properties));
                if (firstValid) {
                    properties = property_1.PropertyValueSet.set(name, property_1.PropertyValue.fromInteger(parseInt(firstValid.value, 10)), properties);
                }
            }
        }
        if (properties === lastProperties) {
            break;
        }
        lastProperties = properties;
    }
    return lastProperties;
}
function createDefaultProperties(properties, selectFirstValue = false, initialPvs = {}) {
    // Remove properties already set in initialPvs, otherwise their values might be overridden.
    const initialProperties = property_1.PropertyValueSet.getPropertyNames(initialPvs);
    const propertiesNotInInitialPvs = properties.filter(p => initialProperties.find(ip => ip === p.name) === undefined);
    const createDefaultProperty = createDefaultPropertyCreator(selectFirstValue);
    const resultSet1 = propertiesNotInInitialPvs.reduce(createDefaultProperty, initialPvs);
    const resultSet2 = propertiesNotInInitialPvs.reduce(createDefaultProperty, resultSet1);
    const resultSet3 = propertiesNotInInitialPvs.reduce(createDefaultProperty, resultSet2);
    return resultSet3;
}
function createDefaultPropertyCreator(selectFirstValue = false) {
    return (mutablePropertyValueSet, property) => {
        var _a;
        const quantity = property.quantity;
        const defaultValue = (_a = property.defaultValues.find(d => property_1.PropertyFilter.isValid(mutablePropertyValueSet, d.propertyFilter))) === null || _a === void 0 ? void 0 : _a.value;
        if (defaultValue !== undefined) {
            setProperty(mutablePropertyValueSet, property.name, defaultValue);
            return mutablePropertyValueSet;
        }
        if (selectFirstValue && property.values && property.values.length > 0) {
            setProperty(mutablePropertyValueSet, property.name, createPropertyValue(quantity, property.values[0].value));
            return mutablePropertyValueSet;
        }
        return mutablePropertyValueSet;
    };
}
function setProperty(mutablePropertyValueSet, name, propertyValue) {
    mutablePropertyValueSet[name] = propertyValue;
}
function createPropertyValue(quantity, value) {
    if (quantity === "Text") {
        return property_1.PropertyValue.fromText(value);
    }
    return property_1.PropertyValue.fromString(value);
}
function getSingleValidValueOrUndefined(productProperty, properties) {
    const quantity = productProperty.quantity;
    if (quantity === "Discrete") {
        const validPropertyValueItems = [];
        for (const productValueItem of productProperty.values) {
            const isValid = PropertyFilterHelpers.isValid(productValueItem.validationFilter, property_1.PropertyFilter.Empty, properties);
            if (isValid) {
                validPropertyValueItems.push(productValueItem);
            }
        }
        return validPropertyValueItems.length === 1
            ? validPropertyValueItems[0]
            : undefined;
    }
    return undefined;
}
//# sourceMappingURL=default-properties.js.map